import React from "react";
import { Link } from "react-router-dom";
import MyLead from './AddLead'
import AddBroker from "./AddBroker";
import AddCall from "./AddCall";
const Navbar = ({ toggleSidebar }) => {
  return (
    <div>
      <header id='header' className='header fixed-top d-flex align-items-center'>
        <div className='d-flex align-items-center justify-content-between'>
          <Link to='/' className='logo d-flex align-items-center'>
            <img
              src='https://app.realdo.in/favicon.png'
              className='h-9'
              alt=''
            />
          </Link>
          <i
            className='bi bi-list toggle-sidebar-btn hidden-desktop'
            id='toggle-sidebar-btn'
            onClick={toggleSidebar}
          ></i>
        </div>
        <div className='Quick Action  '>
        </div>



        <nav className='header-nav ms-auto'>
          <ul className='d-flex align-items-center'>
            <li className='nav-item dropdown'>
              <a className='nav-link nav-icon' href='#' data-bs-toggle='dropdown'>
                <i className='bi bi-bell'></i>
                <span className='badge bg-primary badge-number'>4</span>
              </a>

              <ul className='dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications'>
                <li className='dropdown-header'>
                  You have 4 new notifications
                  <a href='#'>
                    <span className='badge rounded-pill bg-primary p-2 ms-2'>
                      View all
                    </span>
                  </a>
                </li>
                <li>
                  <hr className='dropdown-divider' />
                </li>

                <li className='notification-item'>
                  <i className='bi bi-exclamation-circle text-warning'></i>
                  <div>
                    <h4>Lorem Ipsum</h4>
                    <p>Quae dolorem earum veritatis oditseno</p>
                    <p>30 min. ago</p>
                  </div>
                </li>

                <li>
                  <hr className='dropdown-divider' />
                </li>

                <li className='notification-item'>
                  <i className='bi bi-x-circle text-danger'></i>
                  <div>
                    <h4>Atque rerum nesciunt</h4>
                    <p>Quae dolorem earum veritatis oditseno</p>
                    <p>1 hr. ago</p>
                  </div>
                </li>

                <li>
                  <hr className='dropdown-divider' />
                </li>

                <li className='notification-item'>
                  <i className='bi bi-check-circle text-success'></i>
                  <div>
                    <h4>Sit rerum fuga</h4>
                    <p>Quae dolorem earum veritatis oditseno</p>
                    <p>2 hrs. ago</p>
                  </div>
                </li>

                <li>
                  <hr className='dropdown-divider' />
                </li>

                <li className='notification-item'>
                  <i className='bi bi-info-circle text-primary'></i>
                  <div>
                    <h4>Dicta reprehenderit</h4>
                    <p>Quae dolorem earum veritatis oditseno</p>
                    <p>4 hrs. ago</p>
                  </div>
                </li>

                <li>
                  <hr className='dropdown-divider' />
                </li>
                <li className='dropdown-footer'>
                  <a href='#'>Show all notifications</a>
                </li>
              </ul>
            </li>

            <li className='nav-item dropdown'>
              <a className='nav-link nav-icon' href='#' data-bs-toggle='dropdown'>
                <i className='bi bi-plus-circle'></i>
              </a>

              <ul className='dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications '>
                <li className='dropdown-header'>Quick Actions</li>
                <li>
                  <hr className='dropdown-divider' />
                </li>

                <li className='notification-item' data-bs-toggle="modal" data-bs-target="#addLeadModal">
                  <i className='bi bi-plus-square-fill text-primary'></i>
                  <a href='#'>

                    <div>
                      <h4>Add Lead</h4>
                    </div>
                  </a>
                </li>

                <li>
                  <hr className='dropdown-divider' />
                </li>

                <li className='notification-item' data-bs-toggle="modal" data-bs-target="#addBrokerModal">
                  <i className='bi bi-person-circle text-primary'></i>
                  <div>
                    <h4>Add Broker Lead</h4>
                  </div>
                </li>

                <li>
                  <hr className='dropdown-divider' />
                </li>

                <li className='notification-item' data-bs-toggle="modal" data-bs-target="#addcallModal">
                  <i className='bi-telephone-fill text-primary '></i>
                  <div>
                    <h4>Add Call Lead</h4>
                  </div>
                </li>
              </ul>
            </li>

            <li className='nav-item dropdown pe-3'>
              <a
                className='nav-link nav-profile d-flex align-items-center pe-0'
                href='#'
                data-bs-toggle='dropdown'
              >
                <img
                  src='assets/img/profile-img.jpg'
                  alt='Profile'
                  className='rounded-circle'
                />
                <span className='d-none d-md-block dropdown-toggle ps-2'>
                  K. Anderson
                </span>
              </a>

              <ul className='dropdown-menu dropdown-menu-end dropdown-menu-arrow profile'>
                <li className='dropdown-header'>
                  <h6>Kevin Anderson</h6>
                  <span>Web Designer</span>
                </li>
                <li>
                  <hr className='dropdown-divider' />
                </li>

                <li>
                  <Link
                    className='dropdown-item d-flex align-items-center'
                    to='/profile'
                  >
                    <i className='bi bi-person'></i>
                    <span>My Profile</span>
                  </Link>
                </li>
                <li>
                  <hr className='dropdown-divider' />
                </li>


                <li>
                  <hr className='dropdown-divider' />
                </li>



                <li>
                  <Link className='dropdown-item d-flex align-items-center' to='/login'>
                    <i className='bi bi-box-arrow-right'></i>
                    <span>Sign Out</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </header>
      <MyLead />
      <AddBroker />
      <AddCall />
    </div>

  );
};

export default Navbar;
